import React from "react";

const GoogleMaps = () => {
  return (
    <iframe title="Craftsman Offices" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3604.932588044346!2d55.46587991592614!3d25.373575683814412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f59fff08468a1%3A0x8a26d821a574c0b4!2sCraftsman%20Custom%20Duty%20Free%20Retail%20Units%20Manufactures!5e0!3m2!1sen!2suk!4v1679587991824!5m2!1sen!2suk"  height={null} width={null} style={{border:0, height: "50vh" , minWidth: "100%" , objectFit: "cover"}}   ></iframe>
  );
};

export default GoogleMaps;
